import React, { useState } from 'react';
import { CoinData } from '../../data/coinList';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface AboutCoinProps {
  coin: CoinData;
}

const AboutCoin: React.FC<AboutCoinProps> = ({ coin }) => {
  const [expanded, setExpanded] = useState(false);

  // Mock descriptions for different coins
  const getDescription = (coinId: string) => {
    const descriptions: { [key: string]: string } = {
      bitcoin: `Bitcoin is a decentralized cryptocurrency originally described in a 2008 whitepaper by a person, or group of people, using the alias Satoshi Nakamoto. It was launched soon after, in January 2009.

Bitcoin is a peer-to-peer online currency, meaning that all transactions happen directly between equal, independent network participants, without the need for any intermediary to permit or facilitate them. Bitcoin was created, according to Nakamoto's own words, to allow "online payments to be sent directly from one party to another without going through a financial institution."

Some concepts for a similar type of a decentralized electronic currency precede BTC, but Bitcoin holds the distinction of being the first-ever cryptocurrency to come into actual use.`,
      
      ethereum: `Ethereum is a decentralized open-source blockchain system that features its own cryptocurrency, Ether. ETH works as a platform for numerous other cryptocurrencies, as well as for the execution of decentralized smart contracts.

Ethereum was first described in a 2013 whitepaper by Vitalik Buterin. Buterin, along with other co-founders, secured funding for the project in an online public crowd sale in the summer of 2014. The project team managed to raise $18.3 million in Bitcoin, and Ethereum's price in the Initial Coin Offering (ICO) was $0.311, with over 60 million Ether sold.`,
      
      default: `${coin.name} is a cryptocurrency that operates on a blockchain network. It aims to provide secure, fast, and decentralized transactions for users worldwide. The project focuses on solving key challenges in the cryptocurrency space while maintaining high standards of security and decentralization.

The technology behind ${coin.name} enables peer-to-peer transactions without the need for intermediaries, making it an attractive option for users seeking financial autonomy and privacy.`
    };

    return descriptions[coin.id] || descriptions.default;
  };

  const description = getDescription(coin.id);
  const truncatedDescription = description.substring(0, 300) + '...';

  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">About {coin.name}</h3>
      <div className="text-sm text-zinc-300 leading-relaxed">
        <p>{expanded ? description : truncatedDescription}</p>
        <button
          onClick={() => setExpanded(!expanded)}
          className="flex items-center space-x-1 text-violet-500 hover:text-violet-400 mt-3 transition-colors"
        >
          <span>{expanded ? 'Read less' : 'Read more'}</span>
          {expanded ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
        </button>
      </div>

      <div className="grid grid-cols-2 gap-4 mt-6">
        <div className="bg-zinc-900/50 rounded-lg p-4">
          <h4 className="text-sm font-medium mb-2">Key Features</h4>
          <ul className="text-xs text-zinc-400 space-y-1">
            <li>• Decentralized network</li>
            <li>• Secure transactions</li>
            <li>• Global accessibility</li>
            <li>• Community governed</li>
          </ul>
        </div>
        <div className="bg-zinc-900/50 rounded-lg p-4">
          <h4 className="text-sm font-medium mb-2">Resources</h4>
          <ul className="text-xs space-y-1">
            <li><a href="https://example.com" target="_blank" rel="noopener noreferrer" className="text-violet-500 hover:text-violet-400">Official website</a></li>
            <li><a href="https://example.com/whitepaper" target="_blank" rel="noopener noreferrer" className="text-violet-500 hover:text-violet-400">Whitepaper</a></li>
            <li><a href="https://github.com" target="_blank" rel="noopener noreferrer" className="text-violet-500 hover:text-violet-400">GitHub</a></li>
            <li><a href="https://example.com/community" target="_blank" rel="noopener noreferrer" className="text-violet-500 hover:text-violet-400">Community</a></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AboutCoin;